<template>
    <div class="log-sign_form log-sign_form__login">
        <h1>
            {{ $t('welcomeBack')}}<br>
            <span class="blue-text">{{ $t('loginHeader')}}</span> 
            {{ $t('loginHeader2Part')}}
        </h1>
        <div class="log-sign-form_body">
            <!-- <form action="POST" id="login-form" class="login-form" @submit.prevent="login"> -->
            <div id="login-form" class="login-form">
                <div class="login-form_inputs">
                    <div :class="['input_default_wrap', {'wrong' : wrongLogin}]">
                        <label for="login_email" class="input_default_label">{{ $t('enterYourEmail') }}</label>
                        <input id="login_email" class="input_default input_default__sign-email" type="email" required v-model="email" autocomplete="email" placeholder="example@gmail.com">
                    </div>
                    <div :class="['input_default_wrap', {'wrong' : wrongLogin}]">
                        <label for="login_password" class="input_default_label">{{ $t('enterYourPassword') }}</label>
                        <input id="login_password" class="input_default input_default__sign-pass" type="password" required v-model="password" autocomplete="current-password" :placeholder="$t('loginPasswordlPlaceholder')">
                        <router-link :to="{ name: 'forgot-password'}" class="forgot_pass_link">{{ $t('passwordAreForgetPassword')}}</router-link>
                    </div>
                </div>
                <input type="button" class="btn-default-blue" :disabled="loginBtnDisabled" :value="$t('loginBtnValue')" @click="login(authData)">
            </div>
            <a :href="generateURLWithUTMParams()" class="btn-default-google log-sign-form_google"><img src="img/icons/google.svg" alt="">{{ $t('loginWith')}}</a>
        </div>
        <div class="switch_logsign_wrap">
            <p>{{ $t('dontHaveAccount') }}</p>
            <a class="switch-logsign" :href="generateRegURLWithUTMParams()">{{ $t('loginSignup')}}</a>
        </div>
    </div>
</template>

<script>
import axios from "axios"
export default {
    name: "login-view",
    data(){
        return {
            baseBackendUrl: process.env.VUE_APP_BASE_URL,
            baseFrontUrl: process.env.VUE_APP_FRONT_URL,
            Cookie : "",
            adsquiz_session : "",
            email : "",
            password : "",
            lang: "UA",
            wrongLogin: false,
            userInfo: {
                id: "4",
                email: "user@adsquiz.io",
                name: "",
                role: "user",
                profile: "freelance",
                phone: null,
                password: null,
                interface_lang: "EN",
                tarifs: [
                    {
                        id: "4460",
                        name: "Optimal",
                        price: 20,
                        is_active: true,
                        start_at: 1686843394,
                        end_at: 1689435394
                    }
                ],
                payments: [],
                created_at: 1663934006,
                quizCounter: 0,
                leadCounter: 0,
                isBlocked: false,
                bonuses: []
            },
        }
    },
    computed: {
        authData() {
            return {
                email: this.email.toLowerCase(),
                password: this.password
            }
        },
        loginBtnDisabled() {
            if (!this.email || !this.password) {
                return true
            } else return false
        },
    },
    methods: {
        
        generateURLWithUTMParams() {
            const langParam = `lang=${encodeURIComponent(this.$i18n.locale)}`;
            const utmObject = this.getUTMFromLocalStorage();
            // Если utmObject не пустой, преобразуем его в строку параметров
            const utmParamsString = Object.keys(utmObject).length
                ? Object.keys(utmObject)
                    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(utmObject[key])}`)
                    .join('&')
                : '';
            return `${this.baseBackendUrl}/auth/google?${langParam}${utmParamsString ? `&${utmParamsString}` : ''}`;
        },
        generateRegURLWithUTMParams() {
            const utmObject = this.getUTMFromLocalStorage();
            // Преобразовать объект UTM в строку параметров запроса
            const utmParamsString = Object.keys(utmObject)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(utmObject[key])}`)
                .join('&');

            // Добавить UTM-параметры к базовой ссылке
            return `${this.baseFrontUrl}/register?${utmParamsString}`;
        },
        changeLocale(locale) {
            this.$i18n.locale = locale
            localStorage.setItem('locale_lang', locale);
        },
        async login(authData) {
            if (authData.email && authData.password) {
                var config = {
                    method: 'get',
                    url: process.env.VUE_APP_BASE_URL + '/sanctum/csrf-cookie',
                    headers: {
                        'Accept': 'application/json'
                    }
                };

                axios(config)
                    .then(() => {
                        this.$notify({
                            title: this.$t('notificationLogin')
                        });
                        var FormData = require('form-data');
                        var data = new FormData();
                        data.append('email', authData.email);
                        data.append('password', authData.password);

                        var config = {
                            method: 'post',
                            url: process.env.VUE_APP_BASE_URL + '/login',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                            data: data
                        };

                        axios(config)
                            .then(response => {
                                const status = response.status
                                if (status == 200 || status == 201 || status == 202 || status == 203 || status == 204 || status == 205 || status == 206) {
                                    console.log(status)
                                    localStorage.setItem('isLogin', '1');
                                    this.$router.push({ name: 'workboard-view' })
                                } else if (status == 401) {
                                    console.log(status)

                                    localStorage.setItem('isLogin', '0');

                                    this.$notify({
                                        title: this.$t('notificationWrongLoginData'),
                                        type: 'error',
                                    });
                                } else {
                                    console.log(status)

                                    localStorage.setItem('isLogin', '0');

                                    this.$notify({
                                        title: this.$t('notificationErrorLogin') + " " + status,
                                        type: 'error',
                                    });
                                }
                            })
                            .catch(error => {
                                console.log(error);
                                if (error.code == "ERR_NETWORK") {
                                    this.$notify({
                                        title: this.$t('notificationNetworkError'),
                                        type: 'error',
                                    });
                                } else if (error.response.status == 422) {
                                    this.$notify({
                                        title: this.$t('notificationWrongLoginData'),
                                        type: 'error',
                                    });
                                    this.wrongLogin = true
                                } else if (error.response.status == 419) {
                                    this.$notify({
                                        title: this.$t('notificationCSRFTokenMismatch'),
                                        text: this.$t('notificationReloadPage'),
                                        type: 'error',
                                    });
                                    this.wrongLogin = true
                                } else {
                                    this.$notify({
                                        title: this.$t('notificationErrorLogin') + " " + error.response.status,
                                        type: 'error',
                                    });
                                }

                                localStorage.setItem('isLogin', '0');

                            });
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                let locale_lang = localStorage.getItem('locale_lang')
                if (locale_lang) {
                    this.$i18n.locale = locale_lang
                } else {
                    localStorage.setItem('locale_lang', this.$i18n.locale);
                }
            } else {
                this.$notify({
                    title: this.$t('notificationInputLoginData'),
                    type: 'error',
                });
            }
        },
        helpCrunchLogin(email, name, phone, company, id) {

            /* eslint-disable-next-line */
            HelpCrunch('userAuth', {
                email: email,
                name: name,
                phone: phone,
                company: company,
                user_id: id,
            });
            /* eslint-disable-next-line */
            HelpCrunch('setPhraseList', navigator.language.slice(0, 2));
            /* eslint-disable-next-line */
            HelpCrunch('showChatWidget');
        },
        getUTMFromLocalStorage() {
            const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fpr'];
            const utmObject = {};
            const urlParams = new URLSearchParams(window.location.search);

            for (const utmParam of utmParams) {
                let value = urlParams.get(utmParam);  // Сначала проверяем параметры в URL

                if (!value) {
                    value = sessionStorage.getItem(utmParam);  // Если нет в URL, проверяем sessionStorage
                }

                if (!value) {
                    value = localStorage.getItem(utmParam);  // Если нет в sessionStorage, проверяем localStorage
                }

                if (value) {
                    utmObject[utmParam] = value;
                }
            }

            return utmObject;
        },
    },
    mounted() {
        const queryLang = this.$route.query.lang;
        if (queryLang) {
            const lang = queryLang.toUpperCase();
            if (this.$i18n.availableLocales.includes(lang)) {
                this.lang = lang;
            } else if (lang == 'UK') {
                this.lang = 'UA';
            } else {
                this.lang = 'EN';
            }

            this.changeLocale(this.lang);
        }
    },
    watch: {
        email() {
            this.wrongLogin = false
        },
        password() {
            this.wrongLogin = false
        },
    }
  }
</script>

<style scoped>

</style>
